import observable from 'riot-observable'

export function Model(defaults) {
    if (!(this instanceof Model)) {
        return new Model(defaults);
    }
    var model = this, attributes = Object.assign({}, defaults);

    function get(name) {
        return attributes[name];
    }

    function set(name, newValue) {
        if (typeof name === 'string') {
            var oldValue = attributes[name];
            if (oldValue !== newValue) {
                attributes[name] = newValue;
                this.trigger(name);
            }
        } else {
            var newValues = name;
            for(var key in newValues) set.call(this, key, newValues[key]);
        }
    }

    model.get = get;
    model.set  = set;
    model = observable(model);

    return model;
}
